export const ENDERECOS_LINKS = {
    '-1': 'capas',
    0: '',
    30: 'exemplares',
    33: 'referencia',
    36: 'marc',
    32: "colecao-kardex",
    'summary': "sumarios",
    18: 'reserva',
    31: 'localizacao',
    75: 'solicitacao-emprestimo',
    115: 'dublin-core',
    'sumario_livro': 'sumarios-livros',
    74: 'dados-estatisticos',
    'acervo_fechado': 'acervo-fechado',
    128: 'solicitacao-emprestimo-delivery',
};

export const COD_ATIVIDADE_REFERENCIA = '33';
export const COD_ATIVIDADE_MARC = '36';
export const COD_ATIVIDADE_EXEMPLARES = '30';
export const COD_ATIVIDADE_DUBLIN_CORE = '115';
export const COD_ATIVIDADE_RESERVA = '18';
export const COD_ATIVIDADE_SOLICITACAO_EMPRESTIMO = '75';
export const COD_ATIVIDADE_SOLICITACAO_EMPRESTIMO_DELIVERY = '128';
export const COD_ATIVIDADE_COLECAO_KARDEX = '32';
export const COD_ATIVIDADE_SUMARIOS = 'summary';
export const COD_ATIVIDADE_SUMARIO_LIVRO = 'sumario_livro';
export const COD_ATIVIDADE_DADOS_ESTATISTICOS = '74';
export const SUB_MENU_DETALHES = 'detalhes';
export const SUB_MENU_MENSAGEM_ACERVO_FECHADO = 'mensagem_acervo_fechado'
export const COD_ATIVIDADE_ACERVO_FECHADO = 'acervo_fechado';

//? As chaves do objeto sao as combos da tela, os valores são as colunas do banco usadas para filtrar os dados de cada combo
export const RESERVAS_COMBOS = {
    biblioteca: 'cod_biblioteca',
    volume: 'volume',
    tomo: 'tomo_exemplar',
    parte: 'parte',
    material: 'mat_adicional',
    localizacao: 'cod_local_exemplar',
};